import React, { Component } from 'react';
import {NavLink} from 'react-router-dom'
import PropTypes from 'prop-types';
import classNames from 'classnames';

class AppSubmenu extends Component {

    static defaultProps = {
        className: null,
        items: null,
        onMenuItemClick: null,
        root: false
    }

    static propTypes = {
        className: PropTypes.string,
        items: PropTypes.array,
        onMenuItemClick: PropTypes.func,
        root: PropTypes.bool
    }
    
    constructor(props) {
        super(props);
        this.state = {activeIndex: null};
    }
    
    onMenuItemClick(event, item, index) {
        //avoid processing disabled items
        if(item.disabled) {
            event.preventDefault();
            return true;
        }
                        
        //execute command
        if(item.command) {
            item.command({originalEvent: event, item: item});
        }

        if(index === this.state.activeIndex)
            this.setState({activeIndex: null});    
        else
            this.setState({activeIndex: index});

        if(this.props.onMenuItemClick) {
            this.props.onMenuItemClick({
                originalEvent: event,
                item: item
            });
        }
    }

	// renderLinkContent(item,i) {
	// 	let submenuIcon = item.items && <i className="pi pi-fw pi-angle-down menuitem-toggle-icon"></i>;
	// 	let badge = item.badge && <span className="menuitem-badge">{item.badge}</span>;
    //     const isMaster = item.label === 'Master';
    //     if (isMaster && item.items) {
    //      const active = this.state.activeIndex === i;
    //         return (
    //             <div className="master-menu-item">
    //               <div
    //                 className="master-link"
    //                 onClick={() => {
    //                     this.setState({
    //                         activeIndex: this.state.activeIndex === i ? null : i
    //                     });
    //                 }}
    //             >
    //                 <i className={item.icon}></i>
    //                 <span>{item.label}</span>
    //             </div>

    //                 <i
    //                     className={`pi pi-fw ${
    //                         active ? 'pi-angle-up' : 'pi-angle-down'
    //                     }`}
    //                     onClick={(e) => {
    //                         e.preventDefault();
    //                         e.stopPropagation();

    //                         this.setState({
    //                             activeIndex: active ? null : i
    //                         });
    //                     }}
    //                 />
    //             </div>
    //         );
    //     }

	// 	return (
	// 		<React.Fragment>
	// 			<i className={item.icon}></i>
	// 			<span>{item.label}</span>
	// 			{submenuIcon}
	// 			{badge}
	// 		</React.Fragment>
	// 	);
	// }
    renderLinkContent(item, i) {
        let badge = item.badge && <span className="menuitem-badge">{item.badge}</span>;
        const isMaster = item.label === 'Master';

        if (isMaster && item.items) {
            const active = this.state.activeIndex === i;
            return (
                <div
                    className="master-menu-item"
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        this.setState({
                            activeIndex: active ? null : i
                        });
                    }}
                >
                    <i className={item.icon}></i>

                    <NavLink
                        activeClassName="active-route"
                        to="/master"
                        exact
                        className="master-label-link"
                        onClick={(e) => e.stopPropagation()} // prevent toggle when clicking label
                    >
                        <span>{item.label}</span>
                    </NavLink>

                    {badge}

                    <i
                        className={`pi pi-fw ${active ? 'pi-angle-up' : 'pi-angle-down'} master-arrow-icon`}
                    />
                </div>
            );
        }

        return (
            <React.Fragment>
                <i className={item.icon}></i>
                <span>{item.label}</span>
                {item.items && <i className="pi pi-fw pi-angle-down menuitem-toggle-icon"></i>}
                {badge}
            </React.Fragment>
        );
    }

renderLink(item, i) {
    let content = this.renderLinkContent(item, i); // <-- pass i here

    if (item.to) {
        return (
            <NavLink activeClassName="active-route" to={item.to} onClick={(e) => this.onMenuItemClick(e, item, i)} exact target={item.target}>
                {content}
            </NavLink>
        )
    } else {
        return (
            <a href={item.url} onClick={(e) => this.onMenuItemClick(e, item, i)} target={item.target}>
                {content}
            </a>
        );
    }
}

	// renderLink(item, i) {
	// 	let content = this.renderLinkContent(item);

	// 	if (item.to) {
	// 		return (
	// 			<NavLink activeClassName="active-route" to={item.to} onClick={(e) => this.onMenuItemClick(e, item, i)} exact target={item.target}>
    //                 {content}
    //             </NavLink>
	// 		)
	// 	}
	// 	else {
	// 		return (
	// 			<a href={item.url} onClick={(e) => this.onMenuItemClick(e, item, i)} target={item.target}>
	// 				{content}
	// 			</a>
	// 		);

	// 	}
	// }
    
    render() {
        
        let items = this.props.items && this.props.items.map((item, i) => {
            let active = this.state.activeIndex === i;
            let styleClass = classNames(item.badgeStyleClass, {'active-menuitem': active && !item.to});
            
            return (
                <li className={styleClass} key={i}>
                    {item.items && this.props.root===true && <div className='arrow'></div>}
					{this.renderLink(item, i)}
                    <AppSubmenu items={item.items} onMenuItemClick={this.props.onMenuItemClick}/>
                </li>
            );
        });
        
        return items ? <ul className={this.props.className}>{items}</ul> : null;
    }
}

export class AppMenu extends Component {

    static defaultProps = {
        model: null,
        onMenuItemClick: null
    }

    static propTypes = {
        model: PropTypes.array,
        onMenuItemClick: PropTypes.func
    }

    render() {
        return (
            <div className="layout-menu-container">
                <AppSubmenu items={this.props.model} className="layout-menu" onMenuItemClick={this.props.onMenuItemClick} root={true}/>
            </div>
        );
    }
}